import { useState, useEffect } from 'react';

const useAvailableAssociates = content => {
  const [availableAssociates, setAvailableAssociates] = useState([]);

  const updateChannel = content.roomForChannelType(OTSessionContent.CHANNELTYPE_UPDATE);
  const partnerAssociates = content.Associates.map(associate => {
    return associate;
  });
  const partnerAssociateIds = partnerAssociates.map(associate => {
    return associate.ChatRoom;
  });

  useEffect(() => {
    PubNubCenter.INSTANCE?.addEventListener(
      PubNubCenter.ON_PRESENCE,
      (event: any, presence: any) => {
        if (presence.channel == updateChannel) {
          switch (presence.action) {
            case 'join':
              if (partnerAssociateIds.includes(presence.uuid)) {
                setAvailableAssociates(old => [
                  ...old,
                  partnerAssociates.find(partner => partner.ChatRoom === presence.uuid),
                ]);
              }
              break;
            case 'leave':
              if (partnerAssociateIds.includes(presence.uuid)) {
                setAvailableAssociates(old => old.filter(associate => associate.ChatRoom != presence.uuid));
              }
              break;
            case 'state-change':
              if (presence.state.away == 'away') {
                setAvailableAssociates(old => old.filter(associate => associate.ChatRoom !== presence.uuid));
              }
              if (presence.state.away == 'back') {
                setAvailableAssociates(old => {
                  if (old.find(associate => associate.ChatRoom === presence.uuid)) {
                    return old;
                  } else {
                    return [...old, partnerAssociates.find(partner => partner.ChatRoom === presence.uuid)];
                  }
                });
              }
              break;
            default:
          }
        }
      },

      'available_associate_listeners',
    );

    // DETERMINES ON LOGIN IF THERE ARE ANY ASSOCIATES CURRENTLY LOGGED INTO THE SITE
    // //@ts-ignore
    PubNubCenter.INSTANCE?.mPubNub.hereNow(
      { channels: [updateChannel], includeState: true },
      function (status, response) {
        const UUIDs = response.channels[updateChannel].occupants
          .filter(occupant => occupant.state?.away !== 'away')
          .map(occupant => {
            return occupant.uuid;
          });
        const available = partnerAssociates.filter(associate => {
          return UUIDs.includes(associate.ChatRoom);
        });
        setAvailableAssociates(available);
      },
    );
    return () => {
      // need to clean up our listener

      PubNubCenter.INSTANCE?.removeEventListenerByScope(PubNubCenter.ON_PRESENCE, 'available_associates_listener');
    };
  }, []);

  return availableAssociates;
};

export default useAvailableAssociates;
